<script setup lang="ts">
import { computed } from 'vue'
import { resolveBlockVariant } from './block-registry'
import { resolveBlockBackgroundStyle } from './block-backgrounds'
import type {
  WebsiteBlock,
  WebsiteFormCaptureState,
  WebsiteFormSubmission,
  WebsiteLeadCaptureState,
  WebsiteLeadSubmission,
} from './types'
import SiteImageAttribution from './SiteImageAttribution.vue'

const props = defineProps<{
  block: WebsiteBlock
  leadCapture?: WebsiteLeadCaptureState
  formCapture?: WebsiteFormCaptureState
}>()
const emit = defineEmits<{
  leadSubmit: [submission: WebsiteLeadSubmission]
  formSubmit: [submission: WebsiteFormSubmission]
}>()
const definition = computed(() => resolveBlockVariant(props.block))
const backgroundImage = computed(() => props.block.settings.backgroundImage)
const backgroundStyle = computed(() => resolveBlockBackgroundStyle(props.block.settings))
</script>

<template>
  <div v-if="definition" class="site:relative">
    <component
      :is="definition.component"
      :block="block"
      :lead-capture="block.type === 'contact' || block.type === 'quote' ? leadCapture : undefined"
      :form-capture="formCapture"
      :data-block-id="block.id"
      :data-block-type="block.type"
      :data-block-variant="block.variant"
      :style="backgroundStyle"
      @lead-submit="emit('leadSubmit', $event)"
      @form-submit="emit('formSubmit', $event)"
    />
    <SiteImageAttribution
      v-if="backgroundImage?.attribution"
      :image="backgroundImage"
      class="site:absolute site:bottom-2 site:right-2"
    />
  </div>
  <section v-else class="site-site-container site:py-8" role="alert">
    Unsupported block variation: {{ block.type }}/{{ block.variant }}
  </section>
</template>
